import { render, staticRenderFns } from "./FaceRecognition.vue?vue&type=template&id=c9f04d5a&scoped=true&"
import script from "./FaceRecognition.vue?vue&type=script&lang=js&"
export * from "./FaceRecognition.vue?vue&type=script&lang=js&"
import style0 from "./FaceRecognition.vue?vue&type=style&index=0&id=c9f04d5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f04d5a",
  null
  
)

export default component.exports